'use client'

import clsx from 'clsx'
import { CSSProperties } from 'react'
import { TagDisplaySource, resolveTagDisplay } from '@/utils/tagDisplay'
import { LottieIcon } from '@/components/svg/LottieIcon'

type Props = {
  tag?: TagDisplaySource
  className?: string
  textClassName?: string
  iconClassName?: string
  iconSize?: number
  showTextColor?: boolean
}

export default function TagDisplayLabel({
  tag,
  className,
  textClassName,
  iconClassName,
  iconSize = 20,
  showTextColor = true,
}: Props) {
  const { label, iconType, iconValue, textColor } = resolveTagDisplay(tag)

  if (!label) return null

  const textStyle: CSSProperties | undefined =
    showTextColor && textColor ? { color: textColor } : undefined

  return (
    <span className={clsx('inline-flex items-center gap-1', className)}>
      {iconType === 'emoji' && iconValue ? (
        <span className={clsx('inline-flex leading-none', iconClassName)}>
          {iconValue}
        </span>
      ) : null}
      {iconType === 'asset' && iconValue ? (
        <LottieIcon
          src={iconValue}
          width={iconSize}
          height={iconSize}
          className={iconClassName}
        />
      ) : null}
      <span className={textClassName} style={textStyle}>
        {label}
      </span>
    </span>
  )
}
